/**
 * Google OAuth Configuration for multi-tenant authentication
 *
 * Google OAuth is inherently multi-tenant - any Google account can authenticate
 * Users see Google's standard consent screen on first login
 */

export const googleConfig = {
  clientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || "",

  // Scopes for user profile information
  // These scopes are automatically requested when using Google Sign-In button
  scopes: "openid email profile",
};

/**
 * Check if Google OAuth is configured
 */
export const isGoogleConfigured = (): boolean => {
  return Boolean(import.meta.env.VITE_GOOGLE_CLIENT_ID);
};

/**
 * Check if Microsoft OAuth is configured
 */
export const isMicrosoftConfigured = (): boolean => {
  return Boolean(import.meta.env.VITE_MICROSOFT_CLIENT_ID);
};
